module.exports = __webpack_public_path__ + "static/media/citoesqueleto.31505547.gif";